



















































































































import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class Icon extends Vue {
  @Prop() icon: string
  @Prop() iconwidth: string

  // Data
  private iconNameProxy: unknown = null
  private iconWidthProxy: unknown = null

  async mounted() {
    this.selectedIcon = this.icon
    this.iconWidth = this.iconwidth
  }

  get selectedIcon() {
    return this.iconNameProxy || 'unnamed_icon'
  }
  set selectedIcon(val) {
    this.iconNameProxy = val
  }

  get iconWidth() {
    return this.iconWidthProxy || '20px'
  }
  set iconWidth(val) {
    this.iconWidthProxy = val
  }
}
